import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FlatSelectModule } from '../flat-select/flat-select.module';
import { ColValuesPipe, FilterComponent } from './filter.component';
import { XcHelp2Module } from '@gspwidget/util';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    FilterComponent,
    ColValuesPipe,
  ],
  imports: [
    CommonModule,
    NzSelectModule,
    NzDatePickerModule,
    FormsModule,
    FlatSelectModule,
    XcHelp2Module,
    TranslateModule
  ],
  exports: [
    FilterComponent
  ]
})
export class FilterModule { }
